import { token } from '@atlaskit/tokens';
import React from 'react';

import { getTagForegroundColor, getTagHtmlColor } from '@townsquare/tags';

import { HashIconContainer } from './styles';

export const TagHashIcon = (props: { tagName: string; size: number; overrideColor?: string }) => {
  const name = props.tagName;
  const size = props.size;
  const overrideColor = props.overrideColor;

  return (
    <HashIconContainer color={overrideColor || getTagHtmlColor(name || '')} size={size}>
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.9806 11.1963C20.0889 10.6547 19.7377 10.1279 19.1961 10.0196C18.6546 9.9113 18.1277 10.2625 18.0194 10.8041L17.5802 13.0002H15.6198L15.9806 11.1963C16.0889 10.6547 15.7377 10.1279 15.1961 10.0196C14.6546 9.9113 14.1277 10.2625 14.0194 10.8041L13.5802 13.0002L11 13.0002C10.4477 13.0002 10 13.4479 10 14.0002C10 14.5525 10.4477 15.0002 11 15.0002H13.1802L12.7802 17.0002H11C10.4477 17.0002 10 17.4479 10 18.0002C10 18.5525 10.4477 19.0002 11 19.0002H12.3802L12.0194 20.8041C11.9111 21.3456 12.2623 21.8725 12.8039 21.9808C13.3454 22.0891 13.8723 21.7379 13.9806 21.1963L14.4198 19.0002H16.3802L16.0194 20.8041C15.9111 21.3456 16.2623 21.8725 16.8039 21.9808C17.3454 22.0891 17.8723 21.7379 17.9806 21.1963L18.4198 19.0002H21C21.5523 19.0002 22 18.5525 22 18.0002C22 17.4479 21.5523 17.0002 21 17.0002H18.8198L19.2198 15.0002H21C21.5523 15.0002 22 14.5525 22 14.0002C22 13.4479 21.5523 13.0002 21 13.0002H19.6198L19.9806 11.1963ZM17.1802 15.0002L15.2198 15.0002L14.8198 17.0002H16.7802L17.1802 15.0002Z"
          fill={getTagForegroundColor(name ?? '') ?? token('color.text')}
        />
      </svg>
    </HashIconContainer>
  );
};
